module.exports = __webpack_public_path__ + "img/img-1.d22f830d.svg";